import { Field } from '@base-ui/react/field'

/**
 * @deprecated Use `FormField` from `@alternative/acqua/molecules` instead. The acqua-ui field primitive is being phased out in favor of the acqua design system.
 */
const FieldRoot = Field.Root

const FieldLabel = Field.Label

const FieldControl = Field.Control

const FieldDescription = Field.Description

const FieldError = Field.Error

export { FieldRoot, FieldLabel, FieldControl, FieldDescription, FieldError }
